import { mapActions, mapState } from 'vuex'

export default {
  methods: {
    ...mapActions('auth', ['logout'])
  },
  computed: {
    ...mapState('user', ['currentUser'])
  }
}



// WEBPACK FOOTER //
// ./src/components/app/header/user-dropdown/user-dropdown.js